module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/isarray/index.js
 ** module id = 4191
 ** module chunks = 0
 **/